import React from 'react';

export const Activity = (props: any) => (
  <svg
    data-aid="svgActivity"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3291 20.0005C14.2621 20.0005 14.1931 19.9975 14.1241 19.9905C13.2441 19.9035 12.5541 19.2825 12.3641 18.4075L9.68111 6.0155L6.91811 12.3975C6.75911 12.7635 6.39811 13.0005 6.00011 13.0005H3.00011C2.44711 13.0005 2.00011 12.5525 2.00011 12.0005C2.00011 11.4475 2.44711 11.0005 3.00011 11.0005H5.34411L7.85011 5.2115C8.20511 4.3955 8.98711 3.9205 9.87611 4.0095C10.7561 4.0965 11.4461 4.7175 11.6361 5.5925L14.3191 17.9845L17.0821 11.6025C17.2411 11.2365 17.6011 11.0005 18.0001 11.0005H21.0001C21.5531 11.0005 22.0001 11.4475 22.0001 12.0005C22.0001 12.5525 21.5531 13.0005 21.0001 13.0005H18.6561L16.1501 18.7885C15.8231 19.5415 15.1221 20.0005 14.3291 20.0005Z"
      fill="currentColor"
    />
  </svg>
);
